"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils = require("../../../../common/utils");
var monacoUtils = require("../../monacoUtils");
var jsonCompletions2_1 = require("./service/jsonCompletions2");
var CompletionAdapter = /** @class */ (function () {
    function CompletionAdapter() {
    }
    Object.defineProperty(CompletionAdapter.prototype, "triggerCharacters", {
        get: function () {
            return [' ', ':'];
        },
        enumerable: true,
        configurable: true
    });
    CompletionAdapter.prototype.provideCompletionItems = function (model, position, token) {
        var wordInfo = model.getWordUntilPosition(position);
        var filePath = model.filePath;
        var prefix = wordInfo.word;
        var offset = monacoUtils.positionToOffset(model, position);
        var result = {
            isIncomplete: false,
            items: []
        };
        if (!utils.isSupportedConfigFileForAutocomplete(filePath)) {
            return Promise.resolve(result);
        }
        return jsonCompletions2_1.getCompletionsAtPosition(model, position).then(function (res) {
            return res;
        });
    };
    CompletionAdapter.prototype.resolveCompletionItem = function (item, token) {
        return Promise.resolve(item);
    };
    return CompletionAdapter;
}());
exports.CompletionAdapter = CompletionAdapter;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/monaco/languages/json/autocomplete.js
 ** module id = 426
 ** module chunks = 0
 **/